function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-nocheck
import angular from "angular";
import { $unibase } from "../uni-base-module";
import * as _ from "lodash";
export var SimpleStore = /*#__PURE__*/function () {
  function SimpleStore(key, $log, localStorageService, UniConfig) {
    _classCallCheck(this, SimpleStore);
    this.$log = $log;
    this.localStorageService = localStorageService;
    this.UniConfig = UniConfig;
    this.keyprop = key;
  }
  return _createClass(SimpleStore, [{
    key: "load",
    value: function load(list, keyby) {
      this.$log.debug("Inicializando lista", list);
      this.list = list;

      // si se  pasa un keyby, hacer un dict de los datos
      if (keyby) {
        this.map = _.keyBy(list, keyby);
      }
    }
  }, {
    key: "eliminar",
    value: function eliminar(id) {
      // buscar en la lista el id y eliminar
      this.$log.debug("Eliminando id ", id);
      var idx = _.findIndex(this.list, [this.keyprop, id]);
      if (idx < 0) {
        this.$log.info("** No encontrado índice para " + id);
      } else {
        this.$log.debug("idx en lista ", idx);
        this.list.splice(idx, 1);
      }
    }
  }, {
    key: "nuevo",
    value: function nuevo(object) {
      this.$log.debug("Nuevo modelo", object);

      // if (angular.isDefined (idx)) {}

      this.list.push(object);
    }
  }, {
    key: "actualizar",
    value: function actualizar(object) {
      this.$log.debug("Actualizando modelo : ", object);
      var objkey = object[this.keyprop];
      if (objkey === null || angular.isUndefined(objkey)) {
        this.$log.info("** No encontrado valor en objeto para actualizar " + object);
      } else {
        var obj = _.find(this.list, [this.keyprop, objkey]);
        if (angular.isUndefined(obj)) {
          // se trata como un nuevo elemento del store
          this.$log.info("** No encontrado objeto para key, se trata como nuevo  ", objkey);

          // añadir elemento a la lista
          this.list.push(object);

          // añadir al map de objetos si está definido el map y se clasifica por key
          if (this.keyprop && this.map) {
            this.map[object[this.keyprop]] = object;
          }
        } else {
          this.$log.debug("Actualizando ", obj);
          angular.merge(obj, object);
        }
      }
    }
  }]);
}();
$unibase.factory("SimpleStore", ["$log", "localStorageService", "UniConfig", function ($log, localStorageService, UniConfig) {
  return function (key) {
    return new SimpleStore(key, $log, localStorageService, UniConfig);
  };
}]);